// extracted by mini-css-extract-plugin
var _1 = "styles-module__container___IxJ49";
export { _1 as "container" }
